let _this = {


    /*-------------------------------------------------------------------------------
        # Cache dom and strings
    -------------------------------------------------------------------------------*/
    $dom: {
        mainNavigation: $('.main-navigation'),
        siteHeader: $('.site-header'),
		logoHeight: $('.site-branding')
    },

    vars: {
        screenWidth: 991,
        startPoint: 97
    },

    /*-------------------------------------------------------------------------------
        # Initialize
    -------------------------------------------------------------------------------*/
    init: function () {

        let screenWidth = $(window).width();
        let logoHeight = _this.$dom.logoHeight.height();

        if (screenWidth > _this.vars.screenWidth) {

            $(window).on('scroll load', function () {

                if ($(window).scrollTop() >= logoHeight) {

                    _this.$dom.mainNavigation.addClass('sticky-header');
                    _this.$dom.siteHeader.css('padding-bottom', logoHeight - 27);

                } else if ($(window).scrollTop() < _this.vars.startPoint) {

                    _this.$dom.mainNavigation.removeClass('sticky-header');
                    _this.$dom.siteHeader.css('padding-bottom', '0');

                }
            });

        }
    }
}

export default _this;